document.addEventListener("DOMContentLoaded", function() {
    // new color swatch system that uses metaobject
    const newColorSwatches = document.querySelectorAll('.color-swatches');
    logic(newColorSwatches)

    // handle shopify product recommendation delay
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      let newestColorSwatches = document.querySelectorAll('.color-swatches');
      if ( newestColorSwatches.length != newColorSwatches.length ) {
        logic(newestColorSwatches)
      }
  
      observer.unobserve(productRecommendationsSection);
    }
  
    const productRecommendationsSection = document.querySelector('product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  
    observer.observe(productRecommendationsSection);
  });

  function logic ( swatches ) {
    for (let i = 0; i < swatches.length; i++) {
      const colorsDiv = swatches[i]
      const runJS = colorsDiv.dataset.showAddMoreButton;

      if ( runJS != null && runJS == 'true' ) {
          const numSwatches = colorsDiv.dataset.numSwatches
          const showMoreBtn = colorsDiv.querySelector('.show-more-btn')
    
          const cardInfo = colorsDiv.closest('.card__information')
          const cardHeading = cardInfo.querySelector('.card__heading')
    
          // need set timeout because the swatch colors populate after dom content is loaded, need to wait
          setTimeout(() => {
            const swatches = colorsDiv.querySelectorAll(".swatch-product-color")
            
            for (let j = 0; j < swatches.length; j++) {
              if (j >= numSwatches) {
                swatches[j].classList.add("hide")
              } else {
                swatches[j].classList.remove("hide")
              }
            }
    
            if ( swatches.length > 0 ) {
              cardHeading.classList.add("has-plus-btn")
            }
    
            if (swatches.length > numSwatches && showMoreBtn != null ) {
              showMoreBtn.classList.remove("hide")
              cardHeading.classList.add("has-plus-btn")

              const boundHandleEvent = handleEvent.bind(colorsDiv)
    
              showMoreBtn.removeEventListener("click", boundHandleEvent)
              showMoreBtn.addEventListener("click", boundHandleEvent)
            }
          }, 500)
      }

    }
  }

  function handleEvent() {
    const swatches = this.querySelectorAll(".swatch-product-color");
    const showMoreBtn = this.querySelector('.show-more-btn')


    for (let j = 0; j < swatches.length; j++) {
      swatches[j].classList.remove("hide")
    }
    if ( showMoreBtn != null) {
      showMoreBtn.classList.add("hide")
    }
  }